import { useState } from 'react';
import Modal from './Modal';

/**
 * ปุ่ม "เปิดลิ้นชัก" แบบกดเอง (ไม่ผูกกับบิล เช่น จะทอนเงินโดยไม่มีการขาย) — ต้องกรอกรหัสผ่าน
 * ยืนยันซ้ำทุกครั้งต่างจากตอนเปิดอัตโนมัติหลังคิดเงินสด (ซึ่งคิดเงินเองก็ยืนยันตัวตนอยู่แล้ว)
 * เพื่อให้การเปิดที่ไม่มีบิลอ้างอิงมีร่องรอยว่าใครเป็นคนกดจริง ป้องกันการเปิดพร่ำเพรื่อ
 */
export default function CashDrawerOpenButton({ apiUrl, style }) {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const close = () => { setOpen(false); setPassword(''); setError(''); };

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const res = await fetch(`${apiUrl}/api/printer/cash-drawer/open`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('adminToken')}` },
        body: JSON.stringify({ password })
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(body?.error?.message || 'เปิดลิ้นชักไม่สำเร็จ');
        return;
      }
      close();
    } catch {
      setError('เชื่อมต่อเซิร์ฟเวอร์ไม่ได้');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        style={{
          minHeight: '44px',
          padding: '0 1.25rem',
          borderRadius: '10px',
          border: '1px solid var(--border-strong)',
          background: 'var(--surface-2)',
          color: 'var(--text)',
          fontWeight: 600,
          cursor: 'pointer',
          ...style
        }}
      >
        เปิดลิ้นชัก
      </button>

      <Modal open={open} onClose={submitting ? undefined : close} title="ยืนยันตัวตนเพื่อเปิดลิ้นชัก" maxWidth="360px">
        <form onSubmit={submit}>
          <p style={{ color: 'var(--muted)', fontSize: '0.9rem', marginTop: 0 }}>
            การเปิดลิ้นชักโดยไม่มีบิลจะถูกบันทึกไว้พร้อมชื่อผู้เปิด
          </p>
          <input
            className="dark-input"
            type="password"
            autoFocus
            placeholder="รหัสผ่านของคุณ"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', minHeight: '48px', marginBottom: '0.75rem' }}
          />
          {error && (
            <div style={{ color: 'var(--danger)', fontSize: '0.85rem', marginBottom: '0.75rem' }}>{error}</div>
          )}
          <div style={{ display: 'flex', gap: '0.6rem' }}>
            <button
              type="submit"
              disabled={submitting || !password}
              style={{
                flex: 1,
                minHeight: '48px',
                borderRadius: '10px',
                border: 'none',
                fontWeight: 700,
                cursor: submitting || !password ? 'not-allowed' : 'pointer',
                background: submitting || !password ? 'var(--surface-2)' : 'var(--accent)',
                color: submitting || !password ? 'var(--muted)' : '#1a1206'
              }}
            >
              {submitting ? 'กำลังเปิด...' : 'เปิดลิ้นชัก'}
            </button>
            <button
              type="button"
              disabled={submitting}
              onClick={close}
              style={{ minHeight: '48px', padding: '0 1.25rem', borderRadius: '10px', border: '1px solid var(--border-strong)', background: 'transparent', color: 'var(--text-2)', fontWeight: 600, cursor: 'pointer' }}
            >
              ยกเลิก
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
